type SupportedEnvironment = 'DEV' | 'TEST' | 'STG' | 'TUOTANTO';

interface EnvironmentInfo {
  environmentLabel: SupportedEnvironment;
  cssClassName: string;
  buildLabel: string;
}

const ENVIRONMENT_BY_DEPLOY_ENV: Record<string, SupportedEnvironment> = {
  dev: 'DEV',
  development: 'DEV',
  stest: 'TEST',
  test: 'TEST',
  stg: 'STG',
  staging: 'STG',
  prod: 'TUOTANTO',
  production: 'TUOTANTO',
};

const ENVIRONMENT_CLASS_BY_LABEL: Record<SupportedEnvironment, string> = {
  DEV: 'sidenav--env-dev',
  TEST: 'sidenav--env-test',
  STG: 'sidenav--env-stg',
  TUOTANTO: 'sidenav--env-prod',
};

const resolveEnvironmentLabel = (): SupportedEnvironment => {
  const deployEnv = process.env.REACT_APP_DEPLOY_ENV?.trim().toLowerCase();
  if (deployEnv && ENVIRONMENT_BY_DEPLOY_ENV[deployEnv]) {
    return ENVIRONMENT_BY_DEPLOY_ENV[deployEnv];
  }

  const hostname = window.location.hostname.toLowerCase();

  if (
    hostname.includes('localhost') ||
    hostname.includes('lmr-infobookingv2-frontend-dev-app.azurewebsites.net')
  ) {
    return 'DEV';
  }

  if (
    hostname.includes('stest') ||
    hostname.includes('lmr-infobookingv2-frontend-stest-app.azurewebsites.net')
  ) {
    return 'TEST';
  }

  if (
    hostname.includes('stg.info.lomarengas.fi') ||
    hostname.includes('lmr-infobookingv2-frontend-stg-app.azurewebsites.net')
  ) {
    return 'STG';
  }

  if (
    hostname.includes('info.lomarengas.fi') ||
    hostname.includes('lmr-infobookingv2-frontend-prod-app.azurewebsites.net')
  ) {
    return 'TUOTANTO';
  }

  return 'TUOTANTO';
};

const resolveBuildLabel = (): string => {
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER?.trim();

  if (!buildNumber) {
    return 'BUILD local';
  }

  return `BUILD ${buildNumber}`;
};

export const getEnvironmentInfo = (): EnvironmentInfo => {
  const environmentLabel = resolveEnvironmentLabel();

  return {
    environmentLabel,
    cssClassName: ENVIRONMENT_CLASS_BY_LABEL[environmentLabel],
    buildLabel: resolveBuildLabel(),
  };
};
